var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-cart-sum",class:{'c-cart-sum--alt': _vm.isAlt, }},[_c('p',{staticClass:"c-cart-sum__label"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('p',{staticClass:"c-cart-sum__label"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62420690","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlockCart/BlockCartSummary.vue
// module id = null
// module chunks = 